import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customShortenText',
  pure: false, // required to update the value when the promise is resolved
})
export class CustomShortenTextPipe implements PipeTransform {

  transform(value: string, limit): string {

    
    if(value.length > limit ) {
      return value.substr(0, limit) + ' ...';
    }
    return value;
  }
}

